// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__9QDe4","title":"Header_title__12qql","left":"Header_left__17KuT","clinicName":"Header_clinicName__32Rii"};